import { GetterTree } from 'vuex';
import { QuestionModel } from '@descomplica/dex-models';
import { QuestionState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<QuestionState, RootState> = {
  questionById: (state, questionsGetters) => (questionId: number) => {
    const question = state.questions[questionId.toString()];

    return question ? new QuestionModel(question, questionsGetters) : undefined;
  },
};

export default getters;
